import { memo, useRef } from 'react'
import * as Styled from './styled'
import AddIcon from 'assets/svgr-icons/Plus.svg'
import { useDropdownState } from 'hooks/useDropdownState'
import { ActionsFlyout, Icon } from 'common-components'
import { usePlusButtonActions } from './usePlusButtonActions'
import MediaUploadButton from 'components/MediaUploadButton'
import { useProjectMediaUpload } from 'hooks/project-item-upload'
import { dispatch } from 'store'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { IMediaItem, IUploadMediaItem } from 'types/media'
import { scrollToElementById } from 'utils'
import { useTimelineContext } from 'context/TimelineContext'
import { useEventListener } from 'hooks'
import { TIMELINE_PLUS_BUTTON_CLASS_NAME } from 'consts'

const PlusButton = () => {
  const anchorRef = useRef<HTMLButtonElement | null>(null)
  const uploadTriggerRef = useRef<{ triggerUpload: () => void } | null>(null)
  const { isOpen, toggleDropdown, closeDropdown } = useDropdownState()
  const { scrollableContainerRef } = useTimelineContext()

  useEventListener('scroll', closeDropdown, scrollableContainerRef?.current)

  const onAddMediaItems = (mediaFiles: IMediaItem[]) => {
    dispatch(projectDataThunks.addMediaItems({ value: mediaFiles }))
    scrollToElementById(mediaFiles[0].id)
  }

  const onUploadMedias = (uploadItems: IUploadMediaItem[]) => {
    dispatch(projectDataThunks.uploadMediasToProject(uploadItems))
  }

  const handleFilesUpload = useProjectMediaUpload(
    onAddMediaItems,
    onUploadMedias
  )

  const triggerUpload = () => uploadTriggerRef.current?.triggerUpload()

  const actions = usePlusButtonActions(triggerUpload)

  return (
    <Styled.FixedPlusWrapper>
      <Styled.PlusButtonGlobalStyles />
      <Styled.PlusButtonWrapper
        ref={anchorRef}
        onClick={toggleDropdown}
        className={TIMELINE_PLUS_BUTTON_CLASS_NAME}
      >
        <Icon icon={<AddIcon />} size="medium" color="white" />
      </Styled.PlusButtonWrapper>
      <ActionsFlyout
        isOpen={isOpen}
        anchorEl={anchorRef.current}
        onClose={toggleDropdown}
        actions={actions}
        flyoutOptions={{
          position: 'left',
          alignmentY: 'bottom',
          extraOffset: 8
        }}
        flyoutClassName="plus-button-flyout"
      />
      <MediaUploadButton
        acceptType="visualMedia"
        handleFilesUpload={handleFilesUpload}
        refTrigger={uploadTriggerRef}
      />
    </Styled.FixedPlusWrapper>
  )
}

export default memo(PlusButton)
